<button id="btnSimple" class="btn btn-md btn-block" [ngClass]="{'border-radius-class': enableBorderRadius}" (click)="onClick()" [disabled]="disabled">
    <span class="mx-auto">{{text}}</span>
</button>
